import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import TickerButton from "../input/button/TickerButton";

const Ticker = ({
  name,
  value,
  maxValue,
  onValueChange,
  invertColours,
  hideLabel,
}) => {
  const [pulsing, setPulsing] = useState(false);
  const prevValue = useRef(value);

  useEffect(() => {
    if (prevValue.current !== value) {
      setPulsing(true);
      const timeout = setTimeout(() => setPulsing(false), 250);
      prevValue.current = value;
      return () => clearTimeout(timeout);
    }
  }, [value]);

  const tickUp = () => {
    if (value + 1 <= maxValue) {
      onValueChange(1);
    }
  };

  const tickDown = () => {
    if (value - 1 >= 1) {
      onValueChange(-1);
    }
  };

  const displayClass = `ticker__display ticker__display--${
    invertColours ? 11 - value : value
  }${pulsing ? " ticker__display--pulse" : ""}`;

  return (
    <div className="ticker">
      {!hideLabel && (
        <Typography variant="body1" className="ticker__name">
          {name}
        </Typography>
      )}
      <div className="ticker__control-container">
        <TickerButton
          direction="down"
          onClick={tickDown}
          disabled={value <= 1}
        />
        <div className={displayClass}>
          <Typography variant="h3NoMargin" className="ticker__display-label">
            {value}
          </Typography>
        </div>
        <TickerButton
          direction="up"
          onClick={tickUp}
          disabled={value >= maxValue}
        />
      </div>
    </div>
  );
};

export default Ticker;
